import { redirect } from "@tanstack/react-router";
import { me } from "@/lib/api/auth.functions";
import { canSendNewsletter } from "@/lib/auth/permissions";

/** Redirect to dashboard when the user lacks super-admin newsletter access. */
export async function ensureNewsletterAdminAccess() {
  const user = await me();
  if (!user || !canSendNewsletter(user.permissions)) {
    throw redirect({ to: "/admin" });
  }
}
